## Guiding Principles

#### Foundations for Collaboration

As teams evolve and products scale, the goal of is to develop a living framework for how designers and
engineers collaborate with one another. This means that maintenance is a collective effort, with folks readily
available to champion these efforts as we grow.

#### Efficiency over Process

Our teams operate with agility. The aim is to implement just the right amount of process to enhance design and
development while avoiding unnecessary roadblocks and bottlenecks.

#### Cohesion and Consistency

This library emphasizes optimizing user experience, ensuring that users can seamlessly navigate the platform
regardless of their location within it. When a page is intuitive and consistent, it enables users to
concentrate on their tasks without the distraction of unfamiliar UI elements.

## How do I use this?

Currently, this Library is focused on components in Config and Procure, as their workflows follow similar
patterns and users have overlapping needs. Ideally, we can eventually create a framework that can be applied
to Studio and Showroom as well.

#### As an engineer...

Utilize this library to supplement your workflows, accelerate development, and troubleshoot.

#### As a designer...

Reference this library to understand what components exist, how they function, and find the related Figma
links to be able to leverage them in your designs.

## Important Links

- [Arcade Global Base Styles](https://www.figma.com/design/uqCmATAVpkFx2nt7Aii37o/%F0%9F%91%BE-Arcade-%E2%80%93-Global-Base-Styles?node-id=9621-1375&t=CSmEm2Fnj1hYLxMO-0)
- [Arcade UI](https://www.figma.com/design/DvJihuneOAPAPnZR4wZQhT/%F0%9F%93%90-Arcade-UI?node-id=6888-89140)
- [Brand Toolkit](https://www.figma.com/design/n48ftjKvxqkBpWdYGKTT8j/Brand-Toolkit?t=SR487Cd8KmSmikgC-0)
